import { Component, ElementRef, Input, Renderer2 } from '@angular/core';
import { PrintLabelBackgroundViewModel } from './print-label-background-view-model';
import { LabelData } from '../../../../../models/print-labels/label-data';
import { CardBackgroundComponent } from '../../cards/backgrounds/card-background.component';

@Component({
  template: '',
  standalone: false
})
export abstract class PrintLabelBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public override viewModel: PrintLabelBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: LabelData;
}
